import React from 'react';
import Container from './Container';
import CtaLink from './CtaLink';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <img
          className="footer-watermark"
          src={process.env.PUBLIC_URL + '/images/TimeLine-Express.webp'}
          alt=""
          aria-hidden="true"
        />
        <Container className="footer-grid">
          <div className='flex flex-col gap-5'>
            <h4 className="text-base md:text-lg lg:text-xl">Services</h4>
            <ul className="text-sm md:text-base">
              <li><a href="#services">Freight Forwarding</a></li>
              <li><a href="#services">Warehousing & Distribution</a></li>
              <li><a href="#services">Customs Clearance</a></li>
              <li><a href="#services">Last-Mile Delivery</a></li>
              <li><a href="#services">Express Cargo Services</a></li>
              <li><a href="#services">Supply Chain Solutions</a></li>
            </ul>
          </div>
          <div className='flex flex-col gap-5'>
            <h4 className="text-base md:text-lg lg:text-xl">About Us</h4>
            <ul className="text-sm md:text-base">
              <li><a href="/about#about">About Us</a></li>
              <li><a href="/about#journey">Our Journey</a></li>
              <li><a href="/about#vision-mission">Our Vision and Mission</a></li>
              <li><a href="/about#core-values">Core Values</a></li>
              <li><a href="/about#our-team">Our Team</a></li>
            </ul>
          </div>
          <div className='flex flex-col gap-5'>
            <h4 className="text-base md:text-lg lg:text-xl">Get in Touch</h4>
            <div>
              <p className="muted text-sm md:text-base">Toll-Free Support:</p>
              <p className="contact-phones text-sm md:text-base"><a href="tel:+919168303446">+91 91683 03446</a> | <a href="tel:+919730133446">+91 97301 33446</a></p>
            </div>
            <div>
              <p className="muted text-sm md:text-base">Email Us:</p>
              <p className="text-sm md:text-base"><a href="mailto:info@timelineexpress.in">info@timelineexpress.in</a></p>
            </div>
          </div>
        </Container>
      </div>

      <div className="container footer-cta">
        <Container className="footer-cta-inner">
          <div className="brand">
            <img src="/images/timeline_express_logo.webp" alt="Timeline Express" />
          </div>
          <div className="cta-text text-sm md:text-base lg:text-lg">Need a Logistics Services?</div>
          <CtaLink href="/contact" primaryText="Contact Us" className="text-black" fill="black" />
        </Container>
      </div>

      <div className="footer-bottom">
        <Container>
          <p className="text-sm md:text-base lg:text-lg">Copyright ©{year} All rights reserved.</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
